import React from 'react';
import Icon from '@/components/AppIcon';

/**
 * UGC Benefits Display Component
 * Shows key benefits with icons for UGC pages
 */
const UGCBenefits = () => {
  return (
    <div className="space-y-6">
      <div className="flex gap-4 items-start">
        <div className="flex-shrink-0 w-12 h-12 rounded-lg bg-amber-500/20 flex items-center justify-center">
          <Icon name="Zap" size={24} color="#FCD34D" />
        </div>
        <div>
          <h3 className="font-semibold text-lg text-amber-100 mb-2">Easy Setup</h3>
          <p className="text-amber-100/60">Start creating in minutes. No technical skills needed.</p>
        </div>
      </div>

      <div className="flex gap-4 items-start">
        <div className="flex-shrink-0 w-12 h-12 rounded-lg bg-amber-500/20 flex items-center justify-center">
          <Icon name="DollarSign" size={24} color="#FCD34D" />
        </div>
        <div>
          <h3 className="font-semibold text-lg text-amber-100 mb-2">Earn Real Money</h3>
          <p className="text-amber-100/60">Get paid per review. Start from $50-500 per video.</p>
        </div>
      </div>

      <div className="flex gap-4 items-start">
        <div className="flex-shrink-0 w-12 h-12 rounded-lg bg-amber-500/20 flex items-center justify-center">
          <Icon name="Users" size={24} color="#FCD34D" />
        </div>
        <div>
          <h3 className="font-semibold text-lg text-amber-100 mb-2">Community Support</h3>
          <p className="text-amber-100/60">Learn from other creators in our exclusive community.</p>
        </div>
      </div>

      <div className="bg-white/5 backdrop-blur-sm border border-white/10 rounded-xl p-6">
        <div className="flex items-center gap-2 mb-3">
          <Icon name="Star" size={20} color="#FCD34D" />
          <span className="text-amber-100 font-semibold">Trusted by creators worldwide</span>
        </div>
        <p className="text-amber-100/60 text-sm">Join 5,000+ creators earning consistent income through UGC.</p>
      </div>
    </div>
  );
};

export default UGCBenefits;
